// import { usePropertyCounty } from '../../../../../queries/usePropertyCoreFields';
import { CountyDropDown } from '@apply/components';
import { useExperienceAddressCounty } from '../../../../fields/ExperienceFields';

interface ExperienceCountyProps {
    experienceId: string | undefined;
    required?: boolean;
    selectedState?: string;
    readOnly?: boolean;
    validator?: React.ReactNode;
}

export const ExperienceCounty: React.FC<ExperienceCountyProps> = ({
    experienceId,
    required = false,
    selectedState,
    readOnly = false,
    validator,
}) => {
    const label = 'County ';
    const [county, set_county] = useExperienceAddressCounty(experienceId);
    return (
        <>
            <CountyDropDown
                id='experienceCounty'
                value={county ?? ''}
                onChange={(value) => set_county(value)}
                label={label}
                required={required}
                selectedState={selectedState}
                width='100%'
                readOnly={readOnly}
                validator={validator}
            />
        </>
    );
};
